import React from 'react'

const MyDataPage = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">My Data Page</h1>
      <p>This is a placeholder for the My Data page.</p>
    </div>
  )
}

export default MyDataPage